// import { Permission } from '@/store/modules/user/typing';
import { MenuDataItem } from '@/router/typing';

export const filterChildRoute = (route: MenuDataItem, permissions: string[]) =>
  route.children
    ?.filter(item => {
      const hasAllow = hasAuthority(item, permissions);
      if (item.children && item.children.length > 0) {
        item.children = filterChildRoute(item, permissions!);
      }
      if (hasAllow) {
        return hasAllow;
      } else if (item.children && item.children.length > 0) {
        return true;
      }
      return hasAllow;
    })
    .filter(item => item);

// permissions: Permission[]
export const hasAuthority = (route: MenuDataItem, permissions: string[]) => {
  if (route.meta?.authority) {
    return permissions.some(value => {
      return route.meta?.authority === value;
    });
  }
  return true;
};
